import {
    Box,
    Button,
    Text,
    HStack,
    Switch,
    Slider,
    SliderTrack,
    SliderFilledTrack,
    SliderThumb,
    SliderMark,
    Spinner,
    Collapse,
} from '@chakra-ui/react';
import { useContext, useState } from 'react';
import UIContext from '../context/UIContext';
import { ZeroState } from './ZeroState';
import MapContext from '../context/MapContext';
import { Icon } from '@blueprintjs/core';

export function RouteEditor() {
    const {
        routeResults,
        routeInputWaypoints,
        setRouteInputWaypoints,
        routeSafetyMargin,
        setRouteSafetyMargin,
        routeSimplifyMaxSkipPoints,
        setRouteSimplifyMaxSkipPoints,
        routeSimplify,
        setRouteSimplify
    } = useContext(UIContext);
    const { mapRef } = useContext(MapContext);
    const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);

    let routingState = "pending";
    if (routeResults?.success) {
        routingState = "success";
    }
    if (routeResults && routeResults.success == false) {
        routingState = "failure";
    }
    if (routeInputWaypoints.length < 2) {
        routingState = "add-more-points";
    }

    return (
        <Box w="100%" flex="0 0 auto" display="flex" justifyContent="stretch" alignItems="stretch" flexDir="column">
            <Box p="0px" w="100%">
                {routeInputWaypoints.length < 1 ? (
                    <ZeroState
                    title="No Route"
                    icon="route"
                    description="Right click and use Add Route Point to add points to the route."
                    ></ZeroState>
                ) : (
                    <Box>
                        <HStack p="10px" mb="10px" justifyContent="center" alignItems="center">
                        <Text mb="0px" fontWeight="500">{routeInputWaypoints?.length || 0} point{routeInputWaypoints?.length != 1 && "s"} in Route</Text>
                        <Box flex="1"></Box>
                        <Button variant="outline" colorScheme="red" fontWeight="500" size="sm" onClick={() => setRouteInputWaypoints([])} leftIcon={
                            <Icon icon="trash"></Icon>
                        }>Clear</Button>
                        </HStack>

                        <Box pl="10px" pr="10px">
                            <Text
                                mb="10px"
                                fontWeight="500"
                                textTransform="uppercase"
                                fontSize="12px"
                                pb="1px"
                                borderBottom="1px solid rgba(0,0,0,0.1)"
                            >
                                POINTS
                            </Text>
                        </Box>  
            
                        
                        <Box p="10px" pt="0px" pb="20px">
                        {routeInputWaypoints && routeInputWaypoints.map((point, i) => {
                            return (
                                <Box p="8px" bg="white" border="1px solid rgba(0,0,0,0.1)" mb="10px" key={point.id} cursor="pointer" onClick={() => {
                                    mapRef.current.flyTo({
                                        center: [point.longitude, point.latitude],
                                    });
                                }}>
                                    <HStack mb="0px">
                                    <Box className="route-marker" width="25px" height="25px" boxShadow="none">{i + 1}</Box>
                                    <Text fontWeight="500">{point.latitude.toFixed(6)}, {point.longitude.toFixed(6)}</Text>
                                    <Box flex="1"></Box>
                                    <Button variant="ghost" opacity="0.5" fontWeight="500" w="32px" size="sm" onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault();
                                        setRouteInputWaypoints((old) => {
                                            old.splice(i, 1);
                                            return [...old];
                                        })
                                    }}><Icon icon="trash"></Icon></Button>
                                    </HStack>
                                </Box>
                            )
                        })}
                        </Box>

                        <Box pl="10px" pr="10px">
                            <Text
                                mb="10px"
                                fontWeight="500"
                                textTransform="uppercase"
                                fontSize="12px"
                                pb="1px"
                                borderBottom="1px solid rgba(0,0,0,0.1)"
                            >
                                RESULTS
                            </Text>
                        </Box>

                        <Box pl="10px" pr="10px" h="60px" overflow="hidden">
                            {(routingState == "add-more-points") && (
                                <Box p="8px" bg="white" border="1px solid rgba(0,0,0,0.1)" mb="10px">
                                    <HStack mb="0px">
                                        <Text color="black" opacity="0.2"><Icon icon="map-marker" size='24'></Icon></Text>
                                        <Text fontSize="16px" fontWeight="600" color="black" opacity="0.5">Add More Points</Text>
                                    </HStack>
                                </Box>
                            )}
                            {(routingState == "pending") && (
                                <Box p="8px" bg="white" border="1px solid rgba(0,0,0,0.1)" mb="10px">
                                    <HStack mb="0px">
                                        <Spinner speed="2s" color="blue.500" thickness="3px" />
                                        <Text fontSize="16px" fontWeight="600" color="blue.500">Routing in Progress...</Text>
                                    </HStack>
                                </Box>
                            )}
                            {routingState == "success" && (
                                <Box p="8px" bg="white" border="1px solid rgba(0,0,0,0.1)" mb="10px">
                                    <HStack mb="0px">
                                        <Text color="green.500"><Icon icon="tick" size='24'></Icon></Text>
                                        <Text fontSize="16px" fontWeight="600" color="green.500">Routing Completed</Text>
                                    </HStack>
                                </Box>
                            )}
                            {routingState == "failure" && (
                                <Box p="8px" bg="#ffdddd" border="1px solid rgba(0,0,0,0.1)" mb="10px">
                                    <HStack mb="0px">
                                        <Text color="red.500"><Icon icon="cross" size='24'></Icon></Text>
                                        <Text fontSize="16px" fontWeight="600" color="red.500">Routing Failed</Text>
                                    </HStack>
                                </Box>
                            )}
                        </Box>

                        <Box pl="10px" pr="10px" mt="20px">
                            <HStack justifyContent="stretch" alignItems="stretch"
                                    borderBottom="1px solid rgba(0,0,0,0.1)" 
                                    mb="20px">
                                <Text
                                    fontWeight="500"
                                    textTransform="uppercase"
                                    fontSize="12px"
                                    pb="1px"
                                    mb="0px"
                                >
                                    ADVANCED OPTIONS
                                </Text>
                                <Box flex="1">
                                </Box>
                                <Button variant="ghost" colorScheme="blue" size="xs" mt="-3px" onClick={() => {
                                    setShowAdvancedOptions(!showAdvancedOptions);
                                }}>
                                    {showAdvancedOptions ? "Hide" : "Show"}
                                    <Icon icon={showAdvancedOptions ? "chevron-up" : "chevron-down"}></Icon>
                                </Button>
                            </HStack>
                        </Box>

                        <Collapse in={showAdvancedOptions}>
                            <Box pl="10px" pr="15px" pb="20px" mb="10px">
                                <Text fontSize="14px" fontWeight="500" mb="10px">
                                    Safety Margin: {routeSafetyMargin.toFixed(2)}
                                </Text>
                                <Slider
                                    value={routeSafetyMargin}
                                    onChange={setRouteSafetyMargin}
                                    min={0.0}
                                    max={1.0}
                                    step={0.1}
                                    colorScheme="blue"
                                >
                                    <SliderMark value={0.0} mt="2" ml="0px" fontSize="xs">
                                        Shortest Path
                                    </SliderMark>
                                    <SliderMark value={1.0} mt="2" ml="-115px" w="150px" fontSize="xs">
                                        Wider Safety Margin
                                    </SliderMark>
                                    <SliderTrack>
                                        <SliderFilledTrack />
                                    </SliderTrack>
                                    <SliderThumb />
                                </Slider>
                            </Box>

                            <Box pl="10px" pr="15px" pb="20px" mb="10px">
                                <HStack pt="10px" mb="10px">
                                    <Text fontSize="14px" fontWeight="500">Enable Path Simplification</Text>
                                    <Box flex="1"></Box>
                                    <Switch
                                        isChecked={routeSimplify}
                                        onChange={(e) => setRouteSimplify(e.target.checked)}
                                        colorScheme="blue"
                                    />
                                </HStack>
                                {routeSimplify && (
                                    <Box>
                                        <Text fontSize="14px" fontWeight="400" mb="10px">
                                            Max Skipped Points: {routeSimplifyMaxSkipPoints}
                                        </Text>
                                        <Slider
                                            value={routeSimplifyMaxSkipPoints}
                                            onChange={setRouteSimplifyMaxSkipPoints}
                                            min={1}
                                            max={10}
                                            step={1}
                                            colorScheme="blue"
                                        >
                                            <SliderMark value={1} mt="2" ml="0px" fontSize="xs">
                                                Conservative
                                            </SliderMark>
                                            <SliderMark value={10} mt="2" ml="-65px" fontSize="xs">
                                                Aggressive
                                            </SliderMark>
                                            <SliderTrack>
                                                <SliderFilledTrack />
                                            </SliderTrack>
                                            <SliderThumb />
                                        </Slider>
                                    </Box>
                                )}
                            </Box>
                        </Collapse>
                    </Box>
                )}
            </Box>
            <Box height="0px"></Box>
        </Box>
    );
}
